/**
 * Trigger: tr_debtors_delete
 * Purpose: Update account balances and delete related payments when a debtor is hard deleted
 * Table: debtors
 * Event: BEFORE DELETE
 */
export const TR_DEBTORS_DELETE = `
CREATE TRIGGER tr_debtors_delete
BEFORE DELETE ON debtors FOR EACH ROW
BEGIN
  UPDATE account_balances
  SET debtors_amount = debtors_amount - old.amount
  WHERE old.is_deleted = 0
    AND account_id = old.account_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET debtors_amount = debtors_amount - old.amount
  WHERE old.is_deleted = 0
    AND account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.debtor_date;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );

  DELETE FROM debtor_payments WHERE debtor_id = old._id;
END;
`;
